import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "suga-manage-page" }

import BudgetSugaInfoModal from "@/components/budget/BudgetSugaInfoModal.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'SugaManagePage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<header class=\"console-page-head\"><div class=\"console-page-copy\"><p class=\"console-kicker\">설정</p><h2 class=\"console-title\">수가변경</h2><p class=\"console-desc\">사업·연도별 수가 구간입니다. 예산의 급여총액과 본인부담에 이 값이 쓰입니다.</p></div></header>", 1)),
    _createVNode(BudgetSugaInfoModal)
  ]))
}
}

})